/**
 * Copyright (c) 2018 Mathis Zeiher
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

/* globals console Map Symbol HTMLElement */
import { CustomElement } from './customelement.js';
const componentOptionsSymbol = Symbol('componentoptions');
/**
 * CSSStyleSheetAlike if adoptedStylsheeets are not supported
 */

/**
 * return componentproperties
 *
 * @param target - constructor of CustomElement
 */
export function getComponentProperties(target) {
  // for ES5 compatibility since static properties are not inherited we must manually traverse the protoype chain (for es6 everything works fine)
  let descriptor = Object.getOwnPropertyDescriptor(target, componentOptionsSymbol);

  if (!descriptor) {
    const prototype = Object.getPrototypeOf(target); // get protoype to copy props

    const options = {
      tag: target.name,
      cssStyles: [],
      shadyCSSStyleSheetAdopted: false,
      templateCache: null,
      dependenciesLoaded: false,
      dependenciesLoading: false
    };

    if (prototype !== CustomElement && prototype !== HTMLElement) {
      const superOptions = getComponentProperties(prototype);
      options.dependencies = [...(superOptions.dependencies || [])]; // should be improved by sharing array

      options.inheritStyle = superOptions.inheritStyle;
      options.cssStyles = [...(superOptions.cssStyles || [])];
    }

    Object.defineProperty(target, componentOptionsSymbol, descriptor = {
      enumerable: false,
      configurable: true,
      get: function () {
        return options;
      }
    });
  }

  return descriptor.get();
}
/**
 * set component properties
 *
 * @param target - constructor of CustomElement
 * @param options - options to save
 */

export function setComponentProperties(target, options) {
  Object.defineProperty(target, componentOptionsSymbol, {
    configurable: true,
    enumerable: false,
    get: function () {
      return options;
    }
  });
}
